import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Spinner } from "react-bootstrap";
import mujLogo from "../../assets/logoMUJ.png";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const role = "admin";
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();
  const { setToken, setIsuserloggedin, setRole: setGlobalRole } = useAuth();

  const handleAdminLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      setError("Please fill in both email and password.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/auth/login`,
        {
          role,
          email,
          password,
        }
      );

      if (response.data.success && response.data.token) {
        // Enforce admin-only verification
        if (response.data.role && response.data.role !== "admin") {
          setError("Access denied: Only administrator accounts can access the Admin Portal.");
          setLoading(false);
          return;
        }

        const authData = JSON.stringify({
          loginstatus: true,
          clienttoken: response.data.token,
          loginRole: "admin",
        });
        localStorage.setItem("login", authData);

        setToken(response.data.token);
        setIsuserloggedin(true);
        setGlobalRole("admin");

        navigate("/admin");
      } else {
        setError("Invalid response from server");
      }
    } catch (err) {
      setError(
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err.message ||
        "Failed to connect to authentication server"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #0f172a 0%, #1e293b 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        fontFamily: "'Inter', sans-serif",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "440px",
          background: "rgba(255, 255, 255, 0.98)",
          borderRadius: "16px",
          boxShadow: "0 20px 40px rgba(0, 0, 0, 0.3)",
          padding: "36px 32px",
          textAlign: "center",
        }}
      >
        <div style={{ marginBottom: "20px" }}>
          <img
            src={mujLogo}
            alt="Manipal University Jaipur"
            style={{ maxHeight: "60px", marginBottom: "12px" }}
          />
          <h2
            style={{
              fontSize: "22px",
              fontWeight: 800,
              color: "#0f172a",
              margin: 0,
            }}
          >
            Admin Portal
          </h2>
        </div>

        {error && (
          <div
            style={{
              backgroundColor: "#fef2f2",
              border: "1px solid #fecaca",
              color: "#b91c1c",
              padding: "10px 14px",
              borderRadius: "8px",
              fontSize: "14px",
              marginBottom: "18px",
              textAlign: "left",
            }}
          >
            {error}
          </div>
        )}

        <form onSubmit={handleAdminLogin} style={{ textAlign: "left" }}>
          <div style={{ marginBottom: "16px" }}>
            <label
              style={{
                display: "block",
                fontSize: "13px",
                fontWeight: 600,
                color: "#334155",
                marginBottom: "6px",
              }}
            >
              Admin Email Address
            </label>
            <input
              type="email"
              placeholder="Please enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{
                width: "100%",
                padding: "11px 14px",
                borderRadius: "8px",
                border: "1px solid #cbd5e1",
                fontSize: "14px",
                outline: "none",
              }}
            />
          </div>

          <div style={{ marginBottom: "22px" }}>
            <label
              style={{
                display: "block",
                fontSize: "13px",
                fontWeight: 600,
                color: "#334155",
                marginBottom: "6px",
              }}
            >
              Password
            </label>
            <input
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{
                width: "100%",
                padding: "11px 14px",
                borderRadius: "8px",
                border: "1px solid #cbd5e1",
                fontSize: "14px",
                outline: "none",
              }}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              padding: "13px",
              backgroundColor: "#e06d15",
              color: "#ffffff",
              fontSize: "15px",
              fontWeight: 700,
              border: "none",
              borderRadius: "8px",
              cursor: loading ? "not-allowed" : "pointer",
              boxShadow: "0 4px 12px rgba(224, 109, 21, 0.35)",
              transition: "background-color 0.2s ease",
            }}
          >
            {loading ? (
              <Spinner animation="border" size="sm" />
            ) : (
              "Sign In to Admin Panel"
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
